import { Draft, produce } from 'immer';

const AWSDiagram = require('diagram-maker');
window.AWSDiagram = AWSDiagram;

window.AWSDiagramNUReducer = (state, action) => {
    if (state === undefined) {
        return {};
    }

    state = produce(state, (draftState) => {
        const newSingletonNodes = {};
        for (const [typeId, oldStatus] of Object.entries(state.plugins.singletonNodes)) {
            newSingletonNodes[typeId] = Object.values(state.nodes)
                .map((node) => node.typeId)
                .filter((nodeTypeId) => typeId === nodeTypeId)
                .length > 0;
        }

        draftState.plugins.singletonNodes = newSingletonNodes;
        return draftState;
    })

    switch(action.type) {
        case 'wfAutoSaving':
            return produce(state, (draftState) => {
                draftState.plugins.wfStatus.data = {
                    autoSaveInFlight: true,
                    savedAt: null,
                    errors: {
                        hasError: false,
                        errors: [],
                    },
                };

                return draftState;
            });
        break;

        case 'wfAutoSaved':
            return produce(state, (draftState) => {
                draftState.plugins.wfStatus.data = {
                    autoSaveInFlight: false,
                    savedAt: action.payload.saved.at,
                    errors: {
                        hasError: action.payload.status.hasError,
                        errors: action.payload.status.errors,
                    },
                };

                return draftState;
            });
        break;

        case 'nodeConfigurationUpdated':
            return produce(state, (draftState) => {
                draftState.nodes[action.payload.id].consumerData = action.payload.consumerData;

                return draftState;
            });
        break;

        case 'edgeConfigurationUpdated':
            return produce(state, (draftState) => {
                draftState.edges[action.payload.id].consumerData = action.payload.consumerData;

                return draftState;
            });
        break;

        default:
            return state;
    }
};


